import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useNextPath, withNext } from '../lib/nextPath';
import { Button } from '../components/Button';
import { Card } from '../components/Card';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { search } = useLocation();
  // A share link's "Save to Grove" lands here with ?next=/queue?save=… — honour
  // it so the save completes; otherwise new accounts get the setup page.
  const next = useNextPath('/welcome');
  const { signUp } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signUp(email, password, name);
      navigate(next);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Registration failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-surface-bg">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold" style={{
            background: 'linear-gradient(135deg, #8B5CF6, #06B6D4)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}>grove</h1>
          <p className="mt-2 text-sm text-text-secondary">Create your account</p>
        </div>

        <Card padding="2xl" elevation={1}>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-text-primary mb-1.5">Name</label>
              <input type="text" value={name} onChange={e => setName(e.target.value)} required
                className="w-full px-3 py-2 rounded-lg text-sm text-text-primary bg-surface-0 border border-border-subtle focus:border-prism-violet focus:outline-none transition-colors"
                placeholder="Your name" />
            </div>
            <div>
              <label className="block text-sm font-medium text-text-primary mb-1.5">Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                className="w-full px-3 py-2 rounded-lg text-sm text-text-primary bg-surface-0 border border-border-subtle focus:border-prism-violet focus:outline-none transition-colors"
                placeholder="you@example.com" />
            </div>
            <div>
              <label className="block text-sm font-medium text-text-primary mb-1.5">Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                className="w-full px-3 py-2 rounded-lg text-sm text-text-primary bg-surface-0 border border-border-subtle focus:border-prism-violet focus:outline-none transition-colors"
                placeholder="••••••••" />
            </div>
            {error && <p className="text-red-400 text-sm">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full">
              {loading ? 'Creating account…' : 'Create account'}
            </Button>
          </form>
          <p className="mt-6 text-center text-sm text-text-muted">
            Already have an account?{' '}
            <Link to={withNext('/login', search)} className="text-violet-400 hover:text-violet-300 transition-colors">Sign in</Link>
          </p>
        </Card>
      </div>
    </div>
  );
}
